module.exports = __webpack_public_path__ + "img/jumping-hare.74b67111.svg";